import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Link,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText,
    Avatar,
    Checkbox
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import * as Util from "../../../../services/global.service";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { detailJobData } from "../../../../actions/admin";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const EmployeeData = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },
        expandableIcon: {
            border: "1px solid #DADADA",
            // padding:" 8px",
            width: '20px',
            height: '20px',
            borderRadius: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: '.3s',
            transform: "rotate(90deg)",
            '&.active': {
                transform: "rotate(-90deg)",
            }
        },

    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const classes = useStyles();
    const dispatch = useDispatch();
    let { serial,cycleID } = useParams();
    const [Data, setData] = React.useState({});
    const [status, setStatus] = React.useState(true);
    const [iconIcon, setIconIcon] = React.useState("");
    const [btnIcon, setBtnIcon] = React.useState("");
    const [colorIcon, setColorIcon] = React.useState("");
    const [openIcon, setOpenIcon] = React.useState(false);
    const [displayInactive, setDisplayInactive] = React.useState(false);
    const [backgroundColorValue, setBackgroundColorValue] = React.useState("#5DA196");
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [isCollapse, setCollapse] = React.useState(false);
    const [valueSerial, setValueSerial] = React.useState('');
    const handleStatus = () => {
        setStatus(!status)
    }
    const getDetailJobdatas = () => {
        dispatch(detailJobData(serial,cycleID)).then(resp => {
            setData(resp.data)
        })
    }
    useEffect(() => {
        getDetailJobdatas()
    }, []);
    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    const handleDisplayInactive = () => {
        setDisplayInactive(!displayInactive)
    }
    const handleCollapse = (data) => {
        // setCollapse(!isCollapse)
        if (data !== valueSerial) {

            setValueSerial(data)

        } else {

            setValueSerial("")

        }
    }

    return (
        <>
            <Helmet>
                <title>ADMIN | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/job-data')}>{t('admin.label.jobData')}</span> / <span style={styles.end} >{t('admin.label.employeeData')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('admin.label.employeeData')}
                            </Typography>
                            {Data?.job !== undefined && Data?.job !== null && Data?.job !== "" && Data?.job.length > 0 ?
                                <Typography fontSize={16} lineHeight="23.92px" fontWeight="400" color="#A3A3A3">
                                    {t('admin.label.dateAsOf')}: {Util.dateDayTimeFormatAdmin(Data?.job[0]?.date_as_of)}
                                </Typography>
                                :
                                <Typography fontSize={16} lineHeight="23.92px" fontWeight="400" color="#A3A3A3">
                                    {t('admin.label.dateAsOf')}: -
                                </Typography>
                            }
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%' }} classes={{ root: classes.error }}>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 30px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={24} lineHeight="26.4px" fontWeight={500}>{t('admin.label.employeeProfile')}</Typography>
                                            <Divider sx={{ width: "100%", paddingTop: "10px" }} />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                        <Avatar
                                            src={Util.formatData(Data?.employee?.photo, "-")}
                                            sx={{
                                                width: 150,
                                                height: 150,
                                            }}
                                        />
                                    </Box>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "70px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.employeeID')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.code, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.status')} </Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0, "pointer-events": "none" }}
                                                        control={<IOSSwitch checked={Data?.employee?.status === "active" ? true : false} onChange={() => handleStatus()} />}
                                                        label={Data?.employee?.status === "active" ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} </Typography> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.startDate')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Util.dateDayFormat(Data?.employee?.start_date), "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.endDate')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Util.dateDayFormat(Data?.employee?.end_date), "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.userName')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.username, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.emailAddress')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.email, "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.title')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">
                                                    {Util.formatData(Data?.employee?.title_en, "")} {Data?.employee?.title_en !== "" && Data?.employee?.title_th !== "" ? " / " : ""} {Util.formatData(Data?.employee?.title_th, "")}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.academicTitle')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">
                                                    {Util.formatData(Data?.employee?.academic_title_en, "")} {Data?.employee?.academic_title_en !== "" && Data?.employee?.academic_title_th !== "" ? " / " : ""} {Util.formatData(Data?.employee?.academic_title_th, "")}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.nameEN')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.first_name_en, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.lastNameEN')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.last_name_en, "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.nameTH')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.first_name_th, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.lastNameTH')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.last_name_th, "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.gender')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.gender, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.nationality')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.employee?.nationality, "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.jobLevel')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                {Data?.employee?.job_level !== undefined && Data?.employee?.job_level !== null && Object.keys(Data?.employee?.job_level).length > 0 ?
                                                    <Typography fontSize={16} lineHeight="23.92px">
                                                        {Util.formatData(Data?.employee?.job_level?.code, "")} {Data?.employee?.job_level?.code !== "" && Data?.employee?.job_level?.name !== "" ? " - " : ""} {Util.formatData(Data?.employee?.job_level?.name, "")}
                                                    </Typography>
                                                    : null
                                                }
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.employeeGroup')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                {Data?.employee?.emp_group !== undefined && Data?.employee?.emp_group !== null && Object.keys(Data?.employee?.emp_group).length > 0 ?
                                                    <Typography fontSize={16} lineHeight="23.92px">
                                                        {Util.formatData(Data?.employee?.emp_group?.code, "")} {Data?.employee?.emp_group?.code !== "" && Data?.employee?.emp_group?.name !== "" ? " - " : ""} {Util.formatData(Data?.employee?.emp_group?.name, "")}
                                                    </Typography>
                                                    : null
                                                }
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.employeeSubGroup')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                {Data?.employee?.emp_subgroup !== undefined && Data?.employee?.emp_subgroup !== null && Object.keys(Data?.employee?.emp_subgroup).length > 0 ?
                                                    <Typography fontSize={16} lineHeight="23.92px">
                                                        {Util.formatData(Data?.employee?.emp_subgroup?.code, "")} {Data?.employee?.emp_subgroup?.code !== "" && Data?.employee?.emp_subgroup?.name !== "" ? " - " : ""} {Util.formatData(Data?.employee?.emp_subgroup?.name, "")}
                                                    </Typography>
                                                    : null
                                                }
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.contractRenewal')}</Typography>
                                            <Grid item display="flex" alignItems="center" mt={1}>
                                                <Checkbox color="primary" sx={{ pl: 0, pointerEvents: "none" }} checked={Data?.employee?.is_renewal === true ? true : false} />
                                                <Typography variant="subtitle1" fontSize={16} lineHeight="23.92px" fontWeight={500} color="#404349">{t('label.yes')}</Typography>
                                            </Grid>
                                        </Grid>
                                        {Data?.employee?.is_renewal === true ?
                                            <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important" }}>
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.lastRenewalDate')}</Typography>
                                                <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                    <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Util.dateDayFormat(Data?.employee?.renewal_date), "")}</Typography>
                                                </Box>
                                            </Grid>
                                            : null
                                        }
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" mt={3} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('admin.label.jobData')}
                            </Typography>
                            <Grid item display="flex" alignItems="center" mt={1}>
                                <Checkbox color="primary" sx={{ pl: 0 }} checked={displayInactive} onClick={handleDisplayInactive} />
                                <Typography variant="subtitle1" fontSize={16} lineHeight="23.92px" color="#404349">{t('admin.label.displayInactive')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            {Data?.job !== undefined && Data?.job !== null && Data?.job !== "" && Data?.job.length > 0 ?
                                Data?.job.map((result) => (
                                    <Grid container item mb={4} sx={{ display: displayInactive === false && result?.status !== "active" ? "none" : "block" }}>
                                        <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%', overflow: "hidden", transition: "all 300ms ease-out", maxHeight: valueSerial === result?.serial ? "100%" : "490px" }} classes={{ root: classes.error }}>
                                            <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 30px" }}>
                                                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                                        <Typography variant="subtitle1" fontSize={24} lineHeight="26.4px" fontWeight={500}>{t('admin.label.jobPosition')}</Typography>
                                                        <Box >
                                                            <div className={`clickable ${classes.expandableIcon} ${valueSerial === result?.serial ? 'active' : ''}`} onClick={e => handleCollapse(result.serial)} id="prevent"><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} id="prevent" /></div>
                                                        </Box>
                                                    </Box>
                                                    <Divider sx={{ width: "100%", paddingTop: "10px" }} />
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "70px 0px 20px 40px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.status')} </Typography>
                                                    <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                        <FormGroup >
                                                            <FormControlLabel
                                                                sx={{ m: 0, "pointer-events": "none" }}
                                                                control={<IOSSwitch checked={result?.status === "active" ? true : false} onChange={() => handleStatus()} />}
                                                                label={result?.status === "active" ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                            // disabled
                                                            />
                                                        </FormGroup>
                                                        {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} </Typography> */}
                                                    </Box>
                                                </Grid>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.positionType')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        {result?.position_type !== undefined && result?.position_type !== null && Object.keys(result?.position_type).length > 0 ?
                                                            <Typography fontSize={16} lineHeight="23.92px">
                                                                {Util.formatData(result?.position_type?.name, "")}
                                                            </Typography>
                                                            : null
                                                        }
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.startDate')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Util.dateDayFormat(result?.start_date), "")} </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.endDate')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Util.dateDayFormat(result?.end_date), "")}</Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.label.position')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", minHeight: "40px" }} mt={1}>
                                                        {result?.position !== undefined && result?.position !== null && Object.keys(result?.position).length > 0 ?
                                                            <Typography fontSize={16} lineHeight="23.92px">
                                                                {Util.formatData(result?.position?.code, "")} {result?.position?.code !== "" && result?.position?.name !== "" ? " - " : ""} {Util.formatData(result?.position?.name, "")}
                                                            </Typography>
                                                            : null
                                                        }
                                                    </Box>
                                                </Grid>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.jobCode')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        {result?.job !== undefined && result?.job !== null && Object.keys(result?.job).length > 0 ?
                                                            <Typography fontSize={16} lineHeight="23.92px">
                                                                {Util.formatData(result?.job?.code, "")} {result?.job?.code !== "" && result?.job?.name !== "" ? " - " : ""} {Util.formatData(result?.job?.name, "")}
                                                            </Typography>
                                                            : null
                                                        }
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.label.team')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        {result?.team !== undefined && result?.team !== null && Object.keys(result?.team).length > 0 ?
                                                            <Typography fontSize={16} lineHeight="23.92px">
                                                                {Util.formatData(result?.team?.code, "")} {result?.team?.code !== "" && result?.team?.name !== "" ? " - " : ""} {Util.formatData(result?.team?.name, "")}
                                                            </Typography>
                                                            : null
                                                        }
                                                    </Box>
                                                </Grid>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.reportTo')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        {result?.report_to !== undefined && result?.report_to !== null && Object.keys(result?.report_to).length > 0 ?
                                                            <Typography fontSize={16} lineHeight="23.92px">
                                                                {Util.formatData(result?.report_to?.code, "")} {result?.report_to?.code !== "" && result?.report_to?.fullname !== "" ? " - " : ""} {Util.formatData(result?.report_to?.fullname, "")} {result?.report_to?.position !== "" ? " - " : ""} {Util.formatData(result?.report_to?.position, "")}
                                                            </Typography>
                                                            : null
                                                        }
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.lineGroup')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        {result?.linegroup !== undefined && result?.linegroup !== null && Object.keys(result?.linegroup).length > 0 ?
                                                            <Typography fontSize={16} lineHeight="23.92px">
                                                                {Util.formatData(result?.linegroup?.code !== "not_found" ? result?.linegroup?.code : "", "")} {result?.linegroup?.code !== "" && result?.linegroup?.code !== "not_found" && result?.linegroup?.name !== "" && result?.linegroup?.name !== "not_found" ? " - " : ""} {Util.formatData(result?.linegroup?.name !== "not_found" ? result?.linegroup?.name : "", "")}
                                                            </Typography>
                                                            : null
                                                        }
                                                    </Box>
                                                </Grid>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.headOfOrganization')}</Typography>
                                                    <Grid item display="flex" alignItems="center" mt={1}>
                                                        <Checkbox color="primary" sx={{ pl: 0, pointerEvents: "none" }} checked={result?.is_head_organization} />
                                                        <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('label.yes')}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.sequence')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(result?.seq, "")} </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                                    <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.assignmentRation')}</Typography>
                                                    <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                        <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(result?.assignment_ration, "")}</Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))
                                :
                                <Grid container mt={5} >
                                    <Grid item xs sm md display="flex" flexDirection="column" alignItems="center">
                                        <Box>
                                            <img src={emtyData} alt="emty-data" />
                                        </Box>
                                        <Box pt={2}>
                                            <Typography variant="h1" fontSize={14} lineHeight="21px" fontWeight="300" color="#939393">
                                                {t('label.noData')}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
};
export default EmployeeData;
